// The state must return a function
// to make the module reusable.
// See: https://vuex.vuejs.org/en/modules.html#module-reuse
const state = () => ({
  followUpNew: false,
  followUpEdit: false,
  newRecord: false,
  newContact: false,
  editContact: false,
  editAppointment: false,
});

const getters = {};

const mutations = {
  openModal(state, modal) {
    state[modal] = true
  },
  closeModal(state, modal) {
    state[modal] = false
  },

  openFollowUpNewModal(state) {
    state.followUpNew = true;
  },
  openFollowUpEditModal(state) {
    state.followUpEdit = true;
  },
  openNewRecordModal(state) {
    state.newRecord = true;
  },
  openNewContactModal(state) {
    state.newRecord = true;
  },
  openEditContactModal(state) {
    state.newRecord = true;
  },
};

const actions = {};

const ModalsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default ModalsStore;
